import { describeFields, FieldWidget } from '../common/fields';
import { StudentActivityLogSchema } from './schemas';

export const STUDENT_ACTIVITY_LOG_FIELDS = describeFields(StudentActivityLogSchema, {
  student: {},
  subject: { widget: FieldWidget.Text },
  classId: {},
  teacher: {},
  activityType: { widget: FieldWidget.Text },
  class: {},
  classSize: {},
  reason: {},
  reasonCategory: { widget: FieldWidget.Text },
  actor: {},
  creationDatetime: { widget: FieldWidget.DateTime },
  courseState: { widget: FieldWidget.Text },
  studentState: { widget: FieldWidget.Text },
  attendedLessonsCount: {},
  totalLessonsCount: {},
  recentAttendedTeachers: {},
  recentAttendedLessons: {},
});
